import getAngularModule from 'App/babel/angularHelpers/getAngularModule';

export default () => {
	const FeatureHelper = getAngularModule('FeatureHelper');

	return FeatureHelper.isAvailable(FeatureHelper.Feature.MA_DASHBOARD);
};
